import { data } from '../../svg/MoveDown/data';
import { makeIcon } from '../makeIcon';

export const MoveDown = makeIcon(data, 'move_down', 'MoveDown');

export default MoveDown;
